/* eslint-disable no-console */

// eslint-disable-next-line
function noop() {}

console.log = console.log || noop;
console.error = console.error || noop;
console.groupCollapsed = console.groupCollapsed || noop;
console.group = console.group || noop;
console.groupEnd = console.groupEnd || noop;
